//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SiteFileList from "./SiteFileList";
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  mixins: [GetSiteIdMixin],
  components: {
    SiteFileList: SiteFileList
  },
  data: function data() {
    return {
      tabKeys: '1',
      scopeId: '',
      scope: ''
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var _this = this;

      if (this.tabKeys == '') {
        this.tabKeys = '1';
        var ids = this.getTreeCurrentId();
        this.scopeId = ids[1];
        this.scope = ids[0];
      } else {
        var selectedKey = this.tabKeys;
        this.tabKeys = '';
        this.$nextTick(function () {
          _this.tabKeys = selectedKey;

          var ids = _this.getTreeCurrentId();

          _this.scopeId = ids[1];
          _this.scope = ids[0];
        });
      }
    }
  },
  created: function created() {
    this.tabKeys = '1';
  },
  computed: {},
  methods: {}
};